import Vue from 'vue'
import Router from 'vue-router'
// 引入组件
import maincontainer from '@/pages/mainContainer.vue'
import login from '@/pages/login.vue'
import navigator from '@/pages/ShopNavigator.vue'
import homeEdit from '@/pages/HomeEdit/HomeEdit.vue'
import home from '@/pages/home/Home.vue'
import welfare from '@/pages/welfare/Welfare.vue'
import brandDetail from '@/pages/brands/BrandDetail.vue'
import brandList from '@/pages/brands/BrandList.vue'
import brandTypeDetail from '@/pages/brands/BrandTypeDetail.vue'
import brandTypeList from '@/pages/brands/BrandTypeList.vue'
import classifyDetail from '@/pages/products/ClassifyDetail.vue'
import classifyList from '@/pages/products/ClassifyList.vue'
import topList from '@/pages/products/TopList.vue'
import topDetail from '@/pages/products/TopDetail.vue'
import productDetail from '@/pages/products/ProductDetail.vue'
import productList from '@/pages/products/ProductList.vue'
import tagmanage from '@/pages/wechatTag/TagManage.vue'
import committag from '@/pages/wechatTag/CommitTag.vue'
import systemsetting from '@/pages/SystemSetting.vue'
import preauth from '@/pages/wechatTag/PreAuth.vue'
import order from '@/pages/order/order.vue'
import pointGroupList from '@/pages/point/pointgrouplist.vue'
import pointGroupDetail from '@/pages/point/pointgroupdetail.vue'
import pointGainList from '@/pages/point/pointgainlist.vue'
import pointRank from '@/pages/point/pointrank.vue'
import pointGainDetail from '@/pages/point/pointgaindetail.vue'
import interestedTagGroupList from '@/pages/interestedTag/interestedTagGroupList'
import interestedTagGroupDetail from '@/pages/interestedTag/interestedTagGroupDetail'
import interestedTagList from '@/pages/interestedTag/interestedTagList'
import interestedTagDetail from '@/pages/interestedTag/interestedTagDetail'
import userPoint from '@/pages/point/userpoint.vue'
import userPointConsume from '@/pages/point/userpointconsume.vue'
import organization from '@/pages/organization/Organization.vue'
import employee from '@/pages/organization/Employee.vue'
import userCenter from '@/pages/usercenter/usercenter.vue'
import container from '@/pages/test/container.vue'
import enterpriseSettings from '@/pages/settings/enterpriseSettings.vue'
import mgmList from '@/pages/activity/mgmlist.vue'
import mgmDetail from '@/pages/activity/mgmdetail.vue'
import mgmRank from '@/pages/activity/mgmrank.vue'
import searchRecommend from '@/pages/products/searchRecommend.vue'
import searchRecommendDetail from '@/pages/products/searchRecommendDetail.vue'
import articleDetail from '@/pages/article/ArticleDetail.vue'
import messageList from '@/pages/message/MessageList.vue'
import userDetail from '@/pages/vipcenter/UserDetail.vue'
import articleDimension from '@/pages/vipcenter/ArticleDimension.vue'
import myDimension from '@/pages/vipcenter/MyDimension.vue'
import userDimension from '@/pages/vipcenter/UserDimension.vue'
import userAccessHistory from '@/pages/vipcenter/UserAccessHistory.vue'
import userTagHistory from '@/pages/vipcenter/UserTagHistory.vue'
import clickDimension from '@/pages/vipcenter/ClickDimension.vue'
import searchDimension from '@/pages/vipcenter/searchDimension.vue'
// import userDimension from '@/pages/vipcenter/UserDimension.vue'

Vue.use(Router)

export default new Router({
	// 在创建的 router 对象中，如果不配置 mode，就会使用默认的 hash 模式，该模式下会将路径格式化为 #! 开头。
	// 添加 mode: 'history' 之后将使用 HTML5 history 模式，该模式下没有 # 前缀，而且可以使用 pushState 和 replaceState 来管理记录。
	mode: 'history',
	base:'',
	routes: [{
			path: '/',
			name: 'index',
			component: login,
			meta: {
				noRequireAuth: true, // 判断是否不需要登录
			},
		},
		{
			path: '/login',
			name: 'login',
			component: login,
			meta: {
				noRequireAuth: true, // 判断是否不需要登录
			},
		},
		{
			path: '/maincontainer',
			name: 'maincontainer',
			component: maincontainer,
			redirect: '/home',
			children: [{
					path: '/home',
					name: 'home',
					component: home
				},
				{
					path: '/homeEdit',
					name: 'homeEdit',
					component: homeEdit
				},
				{
					path: '/welfare',
					name: 'welfare',
					component: welfare
				},
				{
					path: '/branddetail',
					name: 'brandDetail',
					component: brandDetail
				},
				{
					path: '/brandlist',
					name: 'brandList',
					component: brandList
				},
				{
					path: '/brandtypedetail',
					name: 'brandTypeDetail',
					component: brandTypeDetail
				},
				{
					path: '/brandtypelist',
					name: 'brandTypeList',
					component: brandTypeList
				},
				{
					path: '/classifydetail',
					name: 'classifyDetail',
					component: classifyDetail
				},
				{
					path: '/classifylist',
					name: 'classifyList',
					component: classifyList
				},
				{
					path: '/toplist',
					name: 'topList',
					component: topList
				},
				{
					path: '/topdetail',
					name: 'topDetail',
					component: topDetail
				},
				{
					path: '/productdetail',
					name: 'productDetail',
					component: productDetail
				},
				{
					path: '/productlist',
					name: 'productList',
					component: productList
				},
				{
					path: '/searchrecommend',
					name: 'searchRecommend',
					component: searchRecommend
				},
				{
					path: '/searchrecommenddetail',
					name: 'searchRecommendDetail',
					component: searchRecommendDetail
				},
				{
					path: '/tagmanage',
					name: 'tagmanage',
					component: tagmanage
				},
				{
					path: '/committag',
					name: 'committag',
					component: committag
				},
				{
					path: '/systemsetting',
					name: 'systemsetting',
					component: systemsetting
				},
				{
					path: '/preauth',
					name: 'preauth',
					component: preauth
				},
				{
					path: '/order',
					name: 'order',
					component: order
				},
				{
					path: '/pointgrouplist',
					name: 'pointgrouplist',
					component: pointGroupList
				},
				{
					path: '/pointgroupdetail',
					name: 'pointGroupDetail',
					component: pointGroupDetail
				},
				{
					path: '/pointgaindetail',
					name: 'pointGainDetail',
					component: pointGainDetail
				},
				{
					path: '/pointgainlist',
					name: 'pointGainList',
					component: pointGainList
				},
				{
					path: '/pointrank',
					name: 'pointRank',
					component: pointRank
				},

				// 兴趣标签
				{
					path: '/interestedtaggrouplist',
					name: 'interestedTagGroupList',
					component: interestedTagGroupList
				},
				{
					path: '/interestedtaggroupdetail',
					name: 'interestedTagGroupDetail',
					component: interestedTagGroupDetail
				},
				{
					path: '/interestedtaglist',
					name: 'interestedTagList',
					component: interestedTagList
				},
				{
					path: '/interestedtagdetail',
					name: 'interestedTagDetail',
					component: interestedTagDetail
				},

				{
					path: '/userpoint',
					name: 'userPoint',
					component: userPoint
				},
				{
					path: '/userpointconsume',
					name: 'userPointConsume',
					component: userPointConsume
				},
				{
					path: '/mgmlist',
					name: 'mgmList',
					component: mgmList
				},
				{
					path: '/mgmdetail',
					name: 'mgmDetail',
					component: mgmDetail
				},
				{
					path: '/mgmrank',
					name: 'mgmRank',
					component: mgmRank
				},
				{
					path: '/userdetail',
					name: 'userDetail',
					component: userDetail
				},
				{
					path: '/articledimension',
					name: 'articleDimension',
					component: articleDimension
				},
				{
					path: '/userdimension',
					name: 'userDimension',
					component: userDimension
				},
				{
					path: '/useraccesshistory',
					name: 'userAccessHistory',
					component: userAccessHistory
				},
				{
					path: '/usertaghistory',
					name: 'userTagHistory',
					component: userTagHistory
				},
				{
					path: '/clickdimension',
					name: 'clickDimension',
					component: clickDimension
				},
				{
					path: '/searchdimension',
					name: 'searchDimension',
					component: searchDimension
				},
				{
					path: '/mydimension',
					name: 'myeDimension',
					component: myDimension
				},

				{
					path: '/organization',
					name: 'organization',
					component: organization
				},
				{
					path: '/employee',
					name: 'employee',
					component: employee
				},
				{
					path: '/enterpriseSettings',
					name: 'enterpriseSettings',
					component: enterpriseSettings,
					children:[{
						path:'plat',
						name:'plat',
						component:()=>import('@/pages/settings/plat.vue')
					},{
						path:'test',
						name:'test',
						component:()=>import('@/pages/settings/test.vue')
					},{
						path:'ApiAccount',
						name:'ApiAccount',
						component:()=>import('@/pages/settings/ApiAccount.vue')
					}]
				},{
					path: '/test',
					name: 'test',
					component: container
				},
				{
					path: '/userCenter',
					name: 'userCenter',
					component: userCenter
				},{
					path: '/datares',
					name: 'datares',
					component: ()=>import('@/pages/datares/datares.vue')
				},{
					path: '/autopage',
					name: 'autopage',
					component: ()=>import('@/pages/autopage/autopage.vue')
				},{
					path: '/automaster',
					name: 'automaster',
					component: ()=>import('@/pages/autopage/automaster.vue')
				},{
					path: '/vip',
					name: 'vip',
					component: ()=>import('@/pages/vipcenter/vip.vue')
				},{
					path: '/role',
					name: 'role',
					component: ()=>import('@/pages/vipcenter/role.vue')
				},{
					path: '/userCondition',
					name: 'userCondition',
					component: ()=>import('@/pages/vipcenter/userCondition.vue')
				},{
					path: '/tanchu',
					name: 'tanchu',
					component: ()=>import('@/pages/tanchu/tanchu.vue')
				},{
					path: '/appintment',
					name: 'appintment',
					component: ()=>import('@/pages/appintment/appintment.vue')
				},{
					path: '/appointmanagement',
					name: 'appointmanagement',
					component: ()=>import('@/pages/appintment/appointmanagement.vue')
				},{
					path: '/storecount',
					name: 'storecount',
					component: ()=>import('@/pages/appintment/storecount.vue')
				},{
					path: '/shopmanagement',
					name: 'shopmanagement',
					component: ()=>import('@/pages/appintment/shopmanagement.vue')
				},{
					path: '/scribe',
					name: 'scribe',
					component: ()=>import('@/pages/subscribe/index.vue')
				},{
					path: '/articleList',
					name: 'articleList',
					component: ()=>import('@/pages/article/ArticleList.vue')
				},{
					path: '/articleDetail',
					name: 'articleDetail',
					component: articleDetail
				},{
					path: '/messageList',
					name: 'messageList',
					component: messageList
				},{
					path: '/',
					name: 'useractivitytable',
					component: ()=>import('@/pages/useractivitytable/useractivitytable.vue')
				},

				{
					path: '/messageBoard',
					name: 'messageBoard',
					component: ()=>import('@/pages/message/MessageBoard.vue')
				}
			]
		},
		{
			path: '/ShopNavigator',
			name: 'ShopNavigator',
			component: navigator
		},
		{
			mode: 'history',
			path: '/ProductPosterPreview',
			name: 'ProductPosterPreview',
			component: ()=>import('@/pages/products/ProductPosterPreview.vue')
		},
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js